const PASSWORD_MANAGER_IGNORE_ATTRIBUTES = {
	// disables 1password password manager https://developer.1password.com/docs/web/compatible-website-design/#ignore-offers-to-save-or-fill-specific-fields
	"data-op-ignore": true,
	// disables bitwarden password manager https://bitwarden.com/help/releasenotes/#2021-06-29
	"data-bwignore": true,
} as const;

export interface IgnorePasswordManagers {
	/**
	 * When true, the input will offer a password manager to save the password and autofill it.
	 *
	 * @default false
	 */
	allowPasswordManager?: boolean;
}

export function ignorePasswordManagerAttributes(
	allowPasswordManager: undefined | boolean,
): undefined | typeof PASSWORD_MANAGER_IGNORE_ATTRIBUTES {
	if (!allowPasswordManager) {
		return PASSWORD_MANAGER_IGNORE_ATTRIBUTES;
	}

	return undefined;
}
